import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SpinnerComponent } from '../../../../../shared/components/az-spinner/spinner.component';
import { PopupContainerComponent } from '../../../../../shared/components/popup/popup-container.component';

@Component({
  selector: 'app-cancel-job-confirm-content',
  standalone: true,
  imports: [SpinnerComponent],
  templateUrl: './cancel-job-confirm-content.component.html',
  styleUrl: './cancel-job-confirm-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CancelJobConfirmContentComponent {
  readonly confirmAction = input.required<() => Promise<void>>();

  private readonly dialogRef = inject(MatDialogRef<PopupContainerComponent>);

  readonly processing = signal(false);

  onNo(): void {
    if (this.processing()) {
      return;
    }
    this.dialogRef.close(undefined);
  }

  async onYes(): Promise<void> {
    if (this.processing()) {
      return;
    }

    this.processing.set(true);
    try {
      await this.confirmAction()();
    } finally {
      this.dialogRef.close(true);
      this.processing.set(false);
    }
  }
}
